var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workerorderindex"
  }, [_c('top'), _vm._v(" "), _c('div', {
    staticClass: "nav"
  }, [_c('router-link', {
    staticStyle: {
      "color": "rgb(31, 55, 61)"
    },
    attrs: {
      "to": {
        path: '/workerorderindex'
      }
    }
  }, [_c('span', [_vm._v("首页")])]), _vm._v(" "), _c('router-link', {
    staticClass: "btna color",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "to": {
        path: '/myorder'
      }
    }
  }, [_vm._v("我的工单")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.hotquestion), function(item) {
    return _c('p', [(item.showNote) ? _c('router-link', {
      attrs: {
        "to": {
          path: '/workinformation',
          query: {
            'id': item.orderId
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.nav(item.orderName)
        }
      }
    }, [_vm._v(_vm._s(item.orderName))]) : _c('router-link', {
      attrs: {
        "to": {
          path: '/workcommit?',
          query: {
            'id': item.orderId
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.nav(item.orderName)
        }
      }
    }, [_vm._v(_vm._s(item.orderName))])], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.allquestion), function(item) {
    return _c('p', [(item.type == 0) ? _c('router-link', {
      attrs: {
        "to": {
          path: '/workaccount?',
          query: {
            'id': item.id,
            'class': ''
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.nav(item.name)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e(), _vm._v(" "), (item.type == 1) ? _c('router-link', {
      attrs: {
        "to": {
          path: '/workaccount?',
          query: {
            'id': item.id,
            'question': ''
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.nav(item.name)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()], 1)
  })], 2)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/workorder/hot.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("热点问题")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/workorder/all.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("全部问题分类")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d261437","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workorder/workerorderindex.vue
// module id = GpRe
// module chunks = 1